import { useEffect, useState } from "react";
import { leerRecientes, registrarReciente } from "@/utils/recientes";

/**
 * Recientes del usuario. Registra el cliente que la URL tiene en pantalla (si hay) y devuelve la lista
 * actualizada: el almacenamiento solo sirve para elegir adónde va `/` y para ordenar el selector.
 */
export function useRecientes(userId: string, slugActivo: string | null): string[] {
  const [recientes, setRecientes] = useState(() => leerRecientes(userId));
  useEffect(() => {
    if (slugActivo) registrarReciente(userId, slugActivo);
    setRecientes(leerRecientes(userId));
  }, [userId, slugActivo]);
  return recientes;
}
